import React, { useMemo } from "react";
import { IProjectStage } from "../core/_models";
import { getProjectStageLink, getStageNavigate, getStageRedirect, stageCompletedCode, stageStatusName } from "../../../../utils/config";
import { Link, useNavigate } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { getStageGate, mergeStagesWithDefault } from "../../../../utils/stageGates";
import { usePermission } from "../../auth";
import PermissionGate from "../../apps/components/UI/PermissionGate";

type StepperProps = {
  stages: IProjectStage[];
  size?: "sm" | "md";
  shape?: "circle" | "square";
  project_id: string;
  clickable?: boolean;
};

const gradients = {
  badge: "linear-gradient(135deg, #3c72e7 0%, #4a8fe0 100%)",
  success: "linear-gradient(135deg, #2ecc71 0%, #40d87e 100%)",
  gray: "linear-gradient(135deg, #8e949a 0%, #a0a8b0 100%)"
};

const GateStepper: React.FC<StepperProps> = ({
  stages,
  size = "md",
  shape = "circle",
  project_id,
  clickable = false,
}) => {
  const { canStage } = usePermission();
  const mergedStages = useMemo(() => {
    return mergeStagesWithDefault(stages);
  }, [stages]);

  const currentStep = mergedStages.findIndex((s) => s.active_gate === 1);

  const getStageGateColor = (gateNumber: number) => {
    if (gateNumber < currentStep) {
      return gradients.success; // Completed stages - medium green
    } else if (gateNumber === currentStep) {
      return gradients.badge; // Current stage - medium blue
    } else {
      return gradients.gray; // Future stages - medium gray
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center gap-2 mb-1 flex-wrap">
      {mergedStages.map((stage, index) => {

        const stepNumber = index;
        const statusColor = getStageGateColor(stepNumber);
        const link = (
          <Link
            // to={stage.dk_stage_status !== "stage_status_1" ? getStageRedirect(project_id, stage.dk_stage) : "#"}
            to={getStageRedirect(project_id, stage.dk_stage)}
            type="button"
            className={`rounded-circle d-flex align-items-center justify-content-center text-white fw-semibold cursor-pointer ${stage.dk_stage_status === "stage_status_1"
              ? "cursor-not-allowed"
              : "cursor-pointer"
              }`
            }
            style={{
              width: "28px",
              height: "28px",
              background: statusColor,
              boxShadow:
                stage.active_gate === 1
                  ? "0 0 0 2px rgba(58, 123, 213, 0.3)"
                  : "none",
              transition: "all 0.2s ease",
              fontSize: "0.75rem",
            }}
          >
            {stepNumber}
          </Link>
        );

        return (
          <div
            key={stage.dk_stage}
            className="stage-gate-indicator d-flex flex-column align-items-center justify-content-center"
          >
            {canStage(stage.dk_stage, 'view') ? (
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id={`gate-step-${stepNumber}`}>
                    {getStageGate(stage.dk_stage)?.stageGate} - {stage.dn_stage}
                  </Tooltip>
                }
              >
                {link}
              </OverlayTrigger>
            ) : (
              <PermissionGate allowed={false}>{link}</PermissionGate>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default GateStepper;
